import React from 'react';
import { Grid, InputAdornment, TextField } from '@mui/material';
import styles from './RibbonPageGroup.module.scss';
import type { IRibbonBtnConfig } from '../RibbonConfig';
import RibbonMenuButton from '../RibbonMenuButton';
import RibbonButtonSize from '../RibbonButtonSize';
import { mdiArrowDownCircleOutline, mdiArrowUpCircleOutline } from '@mdi/js';
import GoToPageController from '../../../Commands/GoToPageController';
import { apryseEventSliceCurrentPage } from '../../../../Redux/ApryseEventSlice';
import { useSelector } from 'react-redux';
import { ApryseSDK } from '../../../../pdf/ApryseSDK';

export default (props: IRibbonBtnConfig) => {
    const currentPageNumber = useSelector(apryseEventSliceCurrentPage);

    const [fieldText, setFieldText] = React.useState<string>(currentPageNumber.toString());

    React.useEffect(() => {
        setFieldText(currentPageNumber.toString());
    }, [currentPageNumber]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFieldText(event.target.value);
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            handleEnterKey();
        } else if (event.key === 'Escape') {
            handleEscapeKey();
        } else {
            const allowed = [
                'Backspace',
                'Delete',
                'ArrowLeft',
                'ArrowRight',
                '0',
                '1',
                '2',
                '3',
                '4',
                '5',
                '6',
                '7',
                '8',
                '9',
            ];

            if (!allowed.includes(event.key)) {
                event.preventDefault();
            }
        }
    };

    const handleEscapeKey = () => {
        // Cancel back to previous value
        setFieldText(currentPageNumber.toString());
    };

    const handleEnterKey = () => {
        if (!fieldText) {
            return;
        }

        switchPageByText();
    };

    const onBlur = () => {
        if (!fieldText) {
            setFieldText(currentPageNumber.toString());
            return;
        }

        switchPageByText();
    };

    const switchPageByText = () => {
        let pageNumber = parseInt(fieldText);

        if (pageNumber < 1) {
            pageNumber = 1;
        }

        if (pageNumber > ApryseSDK.pageCount) {
            pageNumber = ApryseSDK.pageCount;
        }

        ApryseSDK.documentViewer.setCurrentPage(pageNumber, true);
    };

    return (
        <Grid container direction="column" className={styles.pageGroup}>
            <Grid item>
                <RibbonMenuButton
                    className={styles.pageButton}
                    key="btnPageUp"
                    config={new GoToPageController('Up', mdiArrowUpCircleOutline)}
                    size={RibbonButtonSize.SmallIcon}
                />
                <TextField
                    className={styles.input}
                    size="small"
                    value={fieldText}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    onBlur={onBlur}
                    InputProps={{
                        type: 'numeric',
                        endAdornment: (
                            <InputAdornment position="start" className={styles.pages}>
                                / {ApryseSDK.pageCount < 1 ? '' : ApryseSDK.pageCount}
                            </InputAdornment>
                        ),
                    }}
                />
                <RibbonMenuButton
                    className={styles.pageButton}
                    key="btnPageDown"
                    config={new GoToPageController('Down', mdiArrowDownCircleOutline)}
                    size={RibbonButtonSize.SmallIcon}
                />
            </Grid>
            <Grid item>
                <span className={styles.title}>{props.config.GetTitle()}</span>
            </Grid>
        </Grid>
    );
};
